import { ApiService } from 'services/api.service';

export const ShipToLocationsService = angular
    .module('checkout.ShipToLocationsService', [
        ApiService
    ]).service('shipToLocationsService', (apiService, $q) => {
        let shipToLocationCache;
        let getShipToLocationsPromise;

        function get(refreshCache) {
            if (getShipToLocationsPromise) return getShipToLocationsPromise;

            if (shipToLocationCache && !refreshCache) {
                return $q.resolve(shipToLocationCache);
            }

            getShipToLocationsPromise = apiService.getShipToLocations().then((shipToLocation) => {
                shipToLocationCache = shipToLocation;
                getShipToLocationsPromise = undefined;
                return shipToLocation;
            });

            return getShipToLocationsPromise;
        }

        function isCountryAvailable(countryCode) {
            return getCountry(countryCode).then(country => country || $q.reject('Shipping country not available'));
        }

        function getCountry(countryCode) {
            return get().then(shipToLocations => shipToLocations.find(location => location.country === countryCode));
        }

        return {
            get,
            isCountryAvailable
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/shipToLocations.service.js